<template>
  <div class="blog-detail-wrapper">

    <b-row class="blog-list-wrapper">
      <b-card no-body class="col-md-12">
        <b-card-header class="pb-50">
          <h5>
            Фильтр
          </h5>
        </b-card-header>
        <b-card-body>
          <b-row>
            <b-col
                cols="12"
                md="6"
                class="mb-md-0 mb-2"
            >
              <label>Тип списков</label>
              <v-select
                  v-model="type"
                  :options="typeOptions"
                  class="w-100"
                  :reduce="val => val.value"
                  :clearable="false"
              />
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <b-overlay
          :show="listLoading"
          rounded="sm"
      >
        <b-col cols="12" class="d-flex align-items-center justify-content-center mb-2 mb-md-0">
          <b-table
              :items="topicsList"
              responsive
              :fields="tableColumns"
              primary-key="filmId"
              show-empty
              empty-text="No matching records found"
              class="position-relative w-100"
              style="table-layout: fixed;"
          >

            <!-- Column: Topic -->
            <template #cell(topic)="data">
              <div class="d-flex align-items-center">
                <b-form-input
                    v-model="data.item.title"
                    class="flex-grow-1"
                />
                <b-button
                    v-if="isTitleChanged(data.item)"
                    variant="success"
                    class="btn-icon ml-1"
                    size="sm"
                    @click="saveTitle(data.item)"
                >
                  <feather-icon icon="CheckIcon"/>
                </b-button>
              </div>
            </template>

            <!-- Column: Lists -->
            <template #cell(lists)="data">
              <div class="d-flex align-items-center flex-wrap">
                <b-badge
                    v-for="list in data.item.lists"
                    :key="list.id"
                    variant="light-primary"
                    class="mr-50 mb-25"
                >
                  {{ list.title }}
                </b-badge>
                <b-button
                    variant="flat-primary"
                    class="btn-icon"
                    size="sm"
                    @click="openListsModal(data.item)"
                >
                  <feather-icon icon="Edit2Icon"/>
                </b-button>
              </div>
            </template>

            <!-- Column: Subtype -->
            <template #cell(subtype)="data">
              <div class="d-flex align-items-center">
                <v-select
                    v-model="data.item.subtype"
                    :options="subtypeOptions"
                    :reduce="val => val.value"
                    class="flex-grow-1"
                    style="min-width: 200px"
                    :clearable="true"
                    :append-to-body="true"
                    placeholder="Выберите подтип"
                />
                <b-button
                    v-if="isSubtypeChanged(data.item)"
                    variant="success"
                    class="btn-icon ml-1"
                    size="sm"
                    @click="saveSubtype(data.item)"
                >
                  <feather-icon icon="CheckIcon"/>
                </b-button>
              </div>
            </template>

            <!-- Column: Actions -->
            <template #cell(actions)="data">
              <div class="text-nowrap">
                <b-button
                    variant="danger"
                    class="btn-icon"
                    size="sm"
                    @click="confirmDelete(data.item)"
                >
                  <feather-icon icon="TrashIcon"/>
                </b-button>
              </div>
            </template>
          </b-table>


        </b-col>

      </b-overlay>

    </b-row>

    <b-row class="mb-2">
      <b-col cols="12">
        <b-card no-body>
          <b-card-header class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Листы без тем ({{ freeLists.length }})</h5>
            <b-button
                v-b-modal.modal-create-topic
                variant="outline-primary"
                size="sm"
            >
              <feather-icon icon="PlusIcon" class="mr-50"/>
              Добавить вручную
            </b-button>
          </b-card-header>
          <b-table
              :items="freeLists"
              :fields="freeListColumns"
              responsive
              show-empty
              empty-text="Все листы привязаны к темам"
              class="mb-0"
          >
            <template #cell(actions)="data">
              <b-button
                  variant="outline-success"
                  size="sm"
                  :disabled="creatingFromListId !== null"
                  @click="createFromList(data.item)"
              >
                <b-spinner
                    v-if="creatingFromListId === data.item.id"
                    small
                    class="mr-50"
                />
                <feather-icon v-else icon="ZapIcon" class="mr-50"/>
                Создать автотопик
              </b-button>
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>

    <!--/ blogs -->

    <!-- Modal Create Topic -->
    <b-modal
        id="modal-create-topic"
        ref="createTopicModal"
        title="Новая тема"
        ok-title="Добавить"
        cancel-title="Отмена"
        centered
        :ok-disabled="!newTopicName.trim() || createItemLoading"
        @ok.prevent="createItem"
    >
      <b-overlay :show="createItemLoading" rounded="sm">
        <b-form-input
            v-model="newTopicName"
            placeholder="Название"
            autofocus
            @keydown.enter="createItem"
        />
      </b-overlay>
    </b-modal>

    <!-- Modal Edit Lists -->
    <b-modal
        id="modal-edit-lists"
        ref="listsModal"
        :title="editingTopic ? `Листы темы «${editingTopic.title}»` : 'Листы'"
        ok-only
        ok-title="Закрыть"
        ok-variant="secondary"
        centered
        no-close-on-backdrop
    >
      <template v-if="editingTopic">
        <div class="d-flex flex-wrap mb-1">
          <b-badge
              v-for="list in editingTopic.lists"
              :key="list.id"
              variant="light-primary"
              class="mr-50 mb-50 d-flex align-items-center"
          >
            {{ list.title }}
            <feather-icon
                icon="XIcon"
                class="ml-25 cursor-pointer"
                @click="removeListFromTopic(list)"
            />
          </b-badge>
          <span
              v-if="!editingTopic.lists || !editingTopic.lists.length"
              class="text-muted"
          >
            Листы не привязаны
          </span>
        </div>
        <v-select
            v-model="listToAdd"
            label="title"
            :options="availableLists"
            placeholder="Добавить лист..."
            @input="addListToTopic"
        />
      </template>
    </b-modal>

    <!-- Modal Delete Confirmation -->
    <b-modal
        id="modal-delete"
        ref="deleteModal"
        title="Подтверждение удаления"
        ok-variant="danger"
        ok-title="Удалить"
        cancel-title="Отмена"
        centered
        @ok="deleteItem"
    >
      <p>Вы уверены, что хотите удалить тему "{{ itemToDelete ? itemToDelete.title : '' }}"?</p>
    </b-modal>

  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BCardText,
  BCardTitle,
  BMedia,
  BAvatar,
  BMediaAside,
  BMediaBody,
  BImg,
  BCardBody,
  BLink,
  BBadge,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BPagination,
  BCardHeader,
  BTable,
  BOverlay,
  BButton,
  BModal,
  BSpinner,
  VBTooltip,
  VBModal,
} from 'bootstrap-vue'
import {avatarText, badWord, kFormatter, truncateString} from '@core/utils/filter'
import store from "@/store";
import {computed, onUnmounted, ref, watch} from "@vue/composition-api";
import topicsStoreModule from "@/views/topics/topicsStoreModule";
import vSelect from "vue-select";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormInput,
    BCardText,
    BCardBody,
    BCardTitle,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BBadge,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BImg,
    BPagination,
    BCardHeader,
    BTable,
    BButton,
    BOverlay,
    BModal,
    BSpinner,
    vSelect,
  },
  data() {
    return {
      blogSidebar: {},
      disabled: 0,
    }
  },
  directives: {
    'b-tooltip': VBTooltip,
    'b-modal': VBModal,
  },
  methods: {},
  setup() {
    const STORE_MODULE_NAME = 'topics'

    // Register module
    if (!store.hasModule(STORE_MODULE_NAME)) store.registerModule(STORE_MODULE_NAME, topicsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(STORE_MODULE_NAME)) store.unregisterModule(STORE_MODULE_NAME)
    })

    // Table Handlers
    const tableColumns = [
      {key: 'id', label: '#', sortable: false, thStyle: {width: '40px'}},
      {key: 'topic', label: 'Тема', sortable: true, thStyle: {width: '25%'}},
      {key: 'subtype', label: 'Подтип', sortable: true, thStyle: {width: '32%'}},
      {key: 'count', label: 'Кол-во', sortable: true, thStyle: {width: '80px'}},
      {key: 'lists', label: 'Листы', sortable: false},
      {key: 'actions', label: 'Действия', thStyle: {width: '90px'}},
    ]

    const type = ref('music')
    const typeOptions = [
      { label: 'Музыка', value: 'music' },
      { label: 'Фильмы', value: 'movies' },
      { label: 'Сериалы', value: 'series' },
    ]

    const subtypeOptions = [
      { label: 'Матрица (буквы подряд)', value: 'matrix_letters' },
      { label: 'Первая буква', value: 'first_letter' },
      { label: 'Страна', value: 'country' },
      { label: 'Матрица (инициалы)', value: 'matrix_initials' },
      { label: 'Матрица (начало/конец слова)', value: 'matrix_word_edges' },
      { label: 'Тематика', value: 'theme' },
      { label: 'Другие темы в названиях', value: 'other_naming_topics' },
      { label: 'Количество слов', value: 'word_count' },
      { label: 'Количество букв', value: 'letter_count' },
      { label: 'Жанры', value: 'genres' },
      { label: 'Символы в названии', value: 'symbols_in_title' },
      { label: 'Предлоги в названии', value: 'prepositions_in_title' },
      { label: 'Год выхода', value: 'release_year' },
      { label: 'Актеры', value: 'actors' },
      { label: 'Режиссеры', value: 'directors' },
      { label: 'Награды', value: 'awards' },
      { label: 'Студия', value: 'studio' },
      { label: 'Год начала деятельности', value: 'foundation_year' },
      { label: 'Год распада', value: 'dissolution_year' },
      { label: 'Год рождения', value: 'birth_year' },
      { label: 'Год смерти', value: 'death_year' },
    ]

    const freeListColumns = [
      {key: 'title', label: 'Название'},
      {key: 'items_count', label: 'Кол-во', thStyle: {width: '120px'}},
      {key: 'actions', label: '', thStyle: {width: '240px'}, tdClass: 'text-right'},
    ]

    const originalSubtypes = ref({})
    const originalTitles = ref({})

    const topicsList = ref([])
    const createItemLoading = ref(false)
    const newTopicName = ref('')
    const createTopicModal = ref(null)
    const creatingFromListId = ref(null)
    const listLoading = ref(false)
    const lists = ref([])
    const freeLists = ref([])
    const itemToDelete = ref(null)
    const deleteModal = ref(null)
    const fetchTopics = (...args) => store.dispatch('topics/fetchTopics', ...args)
    const updateTopic = (...args) => store.dispatch('topics/updateAutotopic', ...args)
    const addTopic = (...args) => store.dispatch('topics/createAutotopic', ...args)
    const removeTopic = (...args) => store.dispatch('topics/deleteAutotopic', ...args)

    const fetchTopicsList = () => {
      listLoading.value = true;
      const params = {type: type.value}
      fetchTopics({queryParams: params})
          .then(response => {
            topicsList.value = response.data.data
            lists.value = response.data.lists
            freeLists.value = response.data.free_lists
            // Сохраняем оригинальные значения subtype и title
            const subtypes = {}
            const titles = {}
            response.data.data.forEach(item => {
              subtypes[item.id] = item.subtype
              titles[item.id] = item.title
            })
            originalSubtypes.value = subtypes
            originalTitles.value = titles
            listLoading.value = false;
          })
    }

    const registerCreatedItem = (item) => {
      topicsList.value.push(item)
      originalTitles.value = {...originalTitles.value, [item.id]: item.title}
      originalSubtypes.value = {...originalSubtypes.value, [item.id]: item.subtype}
    }

    const createItem = () => {
      const title = newTopicName.value.trim()
      if (!title || createItemLoading.value) return
      createItemLoading.value = true
      addTopic({queryParams: {title, type: type.value}})
        .then(response => {
          registerCreatedItem(response.data.data)
          newTopicName.value = ''
          createTopicModal.value.hide()
        })
        .finally(() => {
          createItemLoading.value = false
        })
    }

    const createFromList = (list) => {
      creatingFromListId.value = list.id
      addTopic({queryParams: {title: list.title, type: type.value, lists: [list.id]}})
        .then(response => {
          registerCreatedItem(response.data.data)
          freeLists.value = freeLists.value.filter(freeList => freeList.id !== list.id)
        })
        .finally(() => {
          creatingFromListId.value = null
        })
    }

    const confirmDelete = (item) => {
      itemToDelete.value = item
      deleteModal.value.show()
    }

    const deleteItem = () => {
      if (!itemToDelete.value) return
      listLoading.value = true
      removeTopic({id: itemToDelete.value.id}).then(() => {
        topicsList.value = topicsList.value.filter(item => item.id !== itemToDelete.value.id)
        itemToDelete.value = null
        listLoading.value = false
      }).catch(() => {
        listLoading.value = false
      })
    }

    const listsModal = ref(null)
    const editingTopic = ref(null)
    const listToAdd = ref(null)

    const availableLists = computed(() => {
      if (!editingTopic.value) return []
      const boundListIds = (editingTopic.value.lists || []).map(list => list.id)
      return lists.value.filter(list => !boundListIds.includes(list.id))
    })

    const openListsModal = (item) => {
      editingTopic.value = item
      listToAdd.value = null
      listsModal.value.show()
    }

    const saveTopicLists = () => {
      const topic = editingTopic.value
      updateTopic({id: topic.id, queryParams: {lists: topic.lists.map(list => list.id)}})
    }

    const removeListFromTopic = (list) => {
      editingTopic.value.lists = (editingTopic.value.lists || []).filter(boundList => boundList.id !== list.id)
      saveTopicLists()
    }

    const addListToTopic = (list) => {
      if (!list) return
      editingTopic.value.lists = [...(editingTopic.value.lists || []), list]
      listToAdd.value = null
      saveTopicLists()
    }

    const isSubtypeChanged = (item) => {
      return item.subtype !== originalSubtypes.value[item.id]
    }

    const saveSubtype = (item) => {
      updateTopic({id: item.id, queryParams: {subtype: item.subtype}}).then(() => {
        originalSubtypes.value = {...originalSubtypes.value, [item.id]: item.subtype}
      })
    }

    const isTitleChanged = (item) => {
      return item.title !== originalTitles.value[item.id]
    }

    const saveTitle = (item) => {
      updateTopic({id: item.id, queryParams: {title: item.title}}).then(() => {
        originalTitles.value = {...originalTitles.value, [item.id]: item.title}
      })
    }

    fetchTopicsList()

    watch(type, () => {
      fetchTopicsList()
    })

    return {
      fetchTopics,
      fetchTopicsList,
      tableColumns,
      topicsList,
      lists,
      freeLists,
      avatarText,
      createItem,
      createFromList,
      creatingFromListId,
      createItemLoading,
      newTopicName,
      createTopicModal,
      freeListColumns,
      listLoading,

      typeOptions,
      type,

      itemToDelete,
      deleteModal,
      confirmDelete,
      deleteItem,

      listsModal,
      editingTopic,
      listToAdd,
      availableLists,
      openListsModal,
      removeListFromTopic,
      addListToTopic,

      subtypeOptions,
      isSubtypeChanged,
      saveSubtype,
      isTitleChanged,
      saveTitle,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-blog.scss';
</style>
